import type { DatesRangeValue } from '@mantine/dates';
import { format } from 'date-fns';

function dateKey(value: Date | string | null | undefined): string | undefined {
  if (!value) {
    return undefined;
  }

  return typeof value === 'string'
    ? value.slice(0, 10)
    : format(value, 'yyyy-MM-dd');
}

export function dateRangeQuery(
  range: DatesRangeValue
): [string | undefined, string | undefined] {
  const [start, end] = range;
  const completedStart = start ?? end;
  const completedEnd = end ?? start;
  return [dateKey(completedStart), dateKey(completedEnd)];
}
